/**
 * Tiny status pill used on the Share Tokens list. Renders one of:
 * active / used / expired / revoked.
 */

import type { ShareTokenStatus } from '../../state/share-token/types.ts';

const STYLES: Record<ShareTokenStatus, string> = {
  active: 'bg-accent/10 text-accent border border-accent/30',
  used: 'bg-muted/10 text-muted border border-muted/30',
  expired: 'bg-warning/10 text-warning border border-warning/30',
  revoked: 'bg-danger/10 text-danger border border-danger/30',
};

export function StatusBadge(props: { status: ShareTokenStatus }): JSX.Element {
  const cls = STYLES[props.status];
  return (
    <span
      className={`inline-flex items-center rounded-pill px-2 py-0.5 font-mono text-xs uppercase tracking-wide ${cls}`}
    >
      {props.status}
    </span>
  );
}
